export default __webpack_public_path__ + "media/images/casatb/experience_right-5578bc5bd90b5fee23838574c2cec01c.png";